import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { closeMuro, openMuro, updateMenus } from '../actions/editor';
export default handleActions({
    [`${updateMenus}`]: (state, action)=>{
        var _state_menuUpdates;
        return _object_spread_props(_object_spread({}, state), {
            menuUpdates: ((_state_menuUpdates = state.menuUpdates) !== null && _state_menuUpdates !== void 0 ? _state_menuUpdates : 0) + 1
        });
    },
    [`${openMuro}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            muroOpen: true,
            muroProps: action.payload.props
        }),
    [`${closeMuro}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            muroOpen: false,
            muroProps: undefined
        })
}, {});

//# sourceMappingURL=editor.js.map